import { Diagram } from 'src/containers/ProjectDiagram/types/diagram';

export const setDiagramSelection =
  (selection?: go.Set<go.Part>, appendSelectionHistory?: boolean) =>
  (diagram: Diagram) => {
    if (appendSelectionHistory !== undefined) {
      // eslint-disable-next-line no-param-reassign
      diagram.appendSelectionHistory = appendSelectionHistory;
    }

    if (selection && selection.size) {
      diagram.selectCollection(selection);
    } else {
      diagram.clearSelection();
    }
  };
